export default __webpack_public_path__ + "static/media/Van32.e73ca59a.webp";